<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card class="statistics-card-line">
		<div :class="{'p-6': hideChart}"
			 slot="no-body"
		>
			<template v-if="widgets !== null">
				<WidgetCard
					v-for="(widget, index) in widgets"
					:key="index"
					:text="widget.statisticTitle"
					:statistic="widget.statistic"
					:iconRight="iconRight"
					:icon="widget.icon"
					:color="widget.color"
					class="multi-item"
				/>
			</template>
			<template v-else>
				<WidgetCard
					v-if="hideChart"
					:text="statisticTitle"
					:statistic="statistic"
					:iconRight="iconRight"
					:icon="icon"
					:color="color"
					:delimited="delimited"
				/>
			</template>

			<div class="line-area-chart" v-if="!hideChart">
				<span class="statistics-card-line__title">{{ statisticTitle }}</span>
				<vue-apex-charts
					style="padding: 0 7px"
					height="350px"
					ref="apexChart"
					type="area"
					:options="chartOptionsProp"
					:series="series"
				/>
			</div>
		</div>
	</vx-card>
</template>

<script>
import WidgetCard from "@/components/statistics-cards/WidgetCard";
import VueApexCharts from 'vue-apexcharts'
import chartConfigs from './chartConfigs.js'
import _color from '@/assets/utils/color.js'

export default {
	props: {
		icon: {
			type: String,
			required: false
		},
		statistic: {
			type: [Number, String],
			required: false
		},
		statisticTitle: {
			type: String
		},
		chartOptionsProp: {
			// type: Array,
			// required: true
		},
		series: {
			type: Array,
			required: false
		},
		color: {
			type: String,
			default: 'disabled'
		},
		colorTo: {
			type: String
		},
		// chartType: {
		//     type: String,
		//     default: 'line-chart',
		// },
		type: {
			type: String,
			default: 'line'
		},
		iconRight: {
			type: Boolean,
			default: false
		},
		hideChart: {
			type: Boolean,
			default: false
		},
		widgets: {
			default: null,
		},
		delimited: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			chartOptions: {
				...this.chartOptionsProp
			},
		}
	},
	components: {
		WidgetCard,
		VueApexCharts
	},
	updated() {
		// console.log(this.series)
	}
}
</script>

<style lang="scss">
.statistics-card-line {
	.line-area-chart {
		display: flex;
		flex-direction: column;
	}

	&__title {
		font-weight: 600;
		font-size: 18px;
		margin-top: 10px;
		margin-left: 20px;
	}

	.multi-item {
		margin-top: 10px;

		&:first-child {
			margin-top: 0;
		}
	}
}
</style>
